import { api } from './api'
import { normalizeComplianceCheckResult } from './complianceCheckResult'

/**
 * @param {string} text
 * @returns {Promise<{ ok: true, result: ReturnType<typeof normalizeComplianceCheckResult> } | { ok: false, error: string }>}
 */
export async function requestComplianceTextCheck(text) {
  const body = String(text || '').trim()
  if (!body) {
    return { ok: false, error: 'empty' }
  }
  try {
    const res = await api.post('/compliance/text-check', { text: body }, { __silent: true })
    const normalized = normalizeComplianceCheckResult(res?.data)
    if (!normalized) {
      return { ok: false, error: 'parse' }
    }
    return { ok: true, result: normalized }
  } catch (e) {
    const msg = e?.response?.data?.message || e?.message || '점검에 실패했습니다.'
    return { ok: false, error: msg }
  }
}
